module.exports = "img/ing-agro-1.24eb2d.jpg";